export const PURCHASE_STATUS = Object.freeze({ DELETED: 0, ACTIVE: 1, EXPIRED: 2, DEACTIVATED: 3, PUBLISHED: 4 });

export function publishDisabledReason(purchase, purchases, now = Date.now()) {
    if (purchase.status !== PURCHASE_STATUS.ACTIVE) return 'Only active purchases can be published.';
    if (!(new Date(purchase.startDate).getTime() <= now && now < new Date(purchase.endDate).getTime())) {
        return 'The purchase must be within its start and end dates.';
    }
    if (purchases.some(other => other.status === PURCHASE_STATUS.PUBLISHED && other.origin === purchase.origin)) {
        return 'Unpublish the current purchase for this portal first.';
    }
    return '';
}
